__turbopack_context__.v({
  "activeType": "contact-module__krtVhq__activeType",
  "contact": "contact-module__krtVhq__contact",
  "detailItem": "contact-module__krtVhq__detailItem",
  "details": "contact-module__krtVhq__details",
  "error": "contact-module__krtVhq__error",
  "errorMsg": "contact-module__krtVhq__errorMsg",
  "form": "contact-module__krtVhq__form",
  "formGroup": "contact-module__krtVhq__formGroup",
  "input": "contact-module__krtVhq__input",
  "label": "contact-module__krtVhq__label",
  "socialIcons": "contact-module__krtVhq__socialIcons",
  "submitBtn": "contact-module__krtVhq__submitBtn",
  "subtitle": "contact-module__krtVhq__subtitle",
  "success": "contact-module__krtVhq__success",
  "text": "contact-module__krtVhq__text",
  "textarea": "contact-module__krtVhq__textarea",
  "title": "contact-module__krtVhq__title",
  "typeSelector": "contact-module__krtVhq__typeSelector",
  "wrapper": "contact-module__krtVhq__wrapper",
});
